/**
 *
 * AssignedMobileGrid
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import AdvancedMobileGrid from 'containers/AdvancedMobileGrid';

import { columnType } from 'domain/typeConstants/table';

import {
  IN_PROGRESS_REQUESTS,
  REQUESTS_FOR_SERVICE_DESK_ASSIGNEE,
} from 'domain/Data/Filters/constants';

import { ASSIGNED_REQUESTS_TABLE_GRID } from './constants';

import {
  addActionButton,
} from '../common/actionButton';
import {
  viewActionItem,
  copyActionItem,
  editActionItem,
  acceptActionItem,
  rejectActionItem,
  completeActionItem,
} from '../common/actionMenu';
import {
  RowComponent, getRowHeight, statusColorLabels,
} from '../common/mobile';

class AssignedMobileGrid extends React.PureComponent { // eslint-disable-line react/prefer-stateless-function
  getFilters() {
    const { viewName } = this.props;
    const filters = [REQUESTS_FOR_SERVICE_DESK_ASSIGNEE];
    if (viewName === 'today') filters.push(IN_PROGRESS_REQUESTS);
    return filters;
  }

  getDetailRowFields() {
    return [
      {
        name: 'number',
        title: '№',
        type: columnType.NUMERIC,
      },
      {
        name: 'actualCreationDate',
        title: 'Добавлено',
        type: columnType.DATE,
      },
      {
        name: 'companyName',
        getValue: (row) => (row.company ? row.company.name : undefined),
        title: 'Арендатор',
      },
      {
        name: 'statusName',
        getValue: (row) => (row.status ? row.status.name : undefined),
        title: 'Статус',
        type: columnType.LABEL,
        labels: statusColorLabels,
      },
      {
        name: 'serviceName',
        getValue: (row) => (row.service ? row.service.name : undefined),
        title: 'Сервис',
      },
      {
        name: 'whereHappened',
        title: 'Где',
      },
      {
        name: 'whatHappened',
        title: 'Что сделать',
      },
      {
        name: 'assigneeName',
        getValue: (row) => (row.assignee ? row.assignee.name : undefined),
        title: 'Исполнитель',
      },
      {
        name: 'executionTerm',
        title: 'Срок исполнения',
        type: columnType.DATE,
      },
      {
        name: 'executionDate',
        title: 'Исполнение факт',
        type: columnType.DATE,
      },
      {
        name: 'fileName',
        getValue: (row) => (row.file ? row.file.name : undefined),
        title: 'Файл',
      },
      {
        name: 'note',
        title: 'Примечание',
      },
    ];
  }

  getActionButtons() {
    return [addActionButton];
  }

  getActionMenuItems() {
    return [viewActionItem, editActionItem, copyActionItem, acceptActionItem, rejectActionItem, completeActionItem];
  }

  getSorting() {
    return [{ columnId: 'number', columnName: 'number', direction: 'desc' }];
  }

  render() {
    const { onActionExecuting, viewName } = this.props;

    return (
      <AdvancedMobileGrid
        entityName="requests"
        name={ASSIGNED_REQUESTS_TABLE_GRID}
        actionButtons={this.getActionButtons()}
        actionMenuItems={this.getActionMenuItems()}
        filters={this.getFilters()}
        onActionExecuting={onActionExecuting}
        sorting={this.getSorting()}
        viewName={viewName}
        detailRowFields={this.getDetailRowFields()}
        rowComponent={RowComponent}
        getRowHeight={getRowHeight}
      />
    );
  }
}

AssignedMobileGrid.propTypes = {
  onActionExecuting: PropTypes.func,
  viewName: PropTypes.string,
};

export default AssignedMobileGrid;
